<template>
  <div class="filter-sort">
    <div class="filter">
      <select class="sml" :value="filter.star" @input="updateFilterStar($event.target.value)">
        <option value="0">All stars</option>
        <option value="1">1+ star</option>
        <option value="2">2+ star</option>
        <option value="3">3+ star</option>
        <option value="4">4+ star</option>
        <option value="5">5+ star</option>
      </select>
      <select class="sml" :value="filter.review" @input="updateFilterReview($event.target.value)">
        <option value="0">All reviews</option>
        <option value="5">5.0+ review</option>
        <option value="6">6.0+ review</option>
        <option value="7">7.0+ review</option>
        <option value="8">8.0+ review</option>
        <option value="9">9.0+ review</option>
      </select>
      <select class="sml" :value="filter.policy" @input="updateFilterPolicy($event.target.value)">
        <option :value="false">All prices</option>
        <option :value="true">In-policy only</option>
      </select>
      <div class="search">
        <input type="text" class="search sml" placeholder="Search property name..." :value="filter.name" @input="updateFilterName($event.target.value)" />
      </div>
      <a v-if="isReset" class="reset" @click="reset">Reset</a>
    </div>
    <div class="sort">
      <select class="sml" :value="sort" @input="updateSort($event.target.value)">
        <option value="nearest">Nearest</option>
        <option value="price-lowest">Price: lowest</option>
        <option value="price-highest">Price: highest</option>
        <option value="guest">Guest rating</option>
        <option value="star">Star rating</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps(["filter", "sort"]);
const emit = defineEmits(["update:filter", "update:sort"]);

// Computed properties
const isReset = computed(() => {
  return props.filter.name != "" || props.filter.policy != false || props.filter.review != 0 || props.filter.star != 0;
});

// Methods
const reset = () => {
  emit("update:filter", { name: "", policy: false, review: 0, star: 0 });
  emit("update:sort", "nearest");
};

const updateFilterName = val => {
  emit("update:filter", {
    name: val,
    policy: props.filter.policy,
    review: props.filter.review,
    star: props.filter.star,
  });
};

const updateFilterPolicy = val => {
  emit("update:filter", {
    name: props.filter.name,
    policy: val,
    review: props.filter.review,
    star: props.filter.star,
  });
};

const updateFilterReview = val => {
  emit("update:filter", {
    name: props.filter.name,
    policy: props.filter.policy,
    review: val,
    star: props.filter.star,
  });
};

const updateFilterStar = val => {
  emit("update:filter", {
    name: props.filter.name,
    policy: props.filter.policy,
    review: props.filter.review,
    star: val,
  });
};

const updateSort = val => {
  emit("update:sort", val);
};
</script>

<style lang="less">
#hotels {
  .filter-sort {
    margin-bottom: 2rem;

    input,
    select {
      margin-bottom: 1rem;
      width: 100%;
    }

    .reset {
      display: block;
      margin-bottom: 1rem;
    }
  }
}

@media screen and (min-width: 60em) {
  #hotels {
    .filter-sort {
      display: flex;

      .filter {
        display: flex;
        flex: 1;

        select {
          margin-right: 1rem;
        }
      }

      input,
      select {
        margin-bottom: 0;
        width: auto;
      }

      .reset {
        align-self: center;
        margin-left: 1rem;
        margin-bottom: 0;
      }
    }
  }
}
</style>
